// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  width: 90%;
  word-wrap: break-word;
}

.error {
  border: 2px solid #dc3545;
}
.error .modal-title {
  color: #dc3545;
}

.success {
  border: 2px solid #198754;
}
.success .modal-title {
  color: #198754;
}`, "",{"version":3,"sources":["webpack://./../shared/ng/components/dialog/simple/dialog.simple.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,qBAAA;AACF;;AAEA;EACE,yBAAA;AACF;AAAE;EACE,cAAA;AAEJ;;AAEA;EACE,yBAAA;AACF;AAAE;EACE,cAAA;AAEJ","sourcesContent":["h2 {\n  width: 90%;\n  word-wrap: break-word;\n}\n\n.error {\n  border: 2px solid #dc3545;\n  & .modal-title {\n    color: #dc3545;\n  }\n}\n\n.success {\n  border: 2px solid #198754;\n  & .modal-title {\n    color: #198754;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
